import { render } from "./BackupLogList.vue?vue&type=template&id=b2653b02"
import script from "./BackupLogList.vue?vue&type=script&lang=js"
export * from "./BackupLogList.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__